// Country-aware postal/ZIP code validation.
// Returns true if value is empty (so requiredness can be handled elsewhere), or matches the country's format.

const patterns: { [country: string]: RegExp } = {
  // DACH
  DE: /^[0-9]{5}$/,
  AT: /^[0-9]{4}$/,
  CH: /^[0-9]{4}$/,
  // UK
  GB: /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i,
  // France, Spain, Italy, Netherlands, Belgium, Portugal
  FR: /^[0-9]{5}$/,
  ES: /^[0-9]{5}$/,
  IT: /^[0-9]{5}$/,
  NL: /^[0-9]{4}\s?[A-Z]{2}$/i,
  BE: /^[0-9]{4}$/,
  PT: /^[0-9]{4}(-[0-9]{3})?$/,
  // Nordics
  SE: /^[0-9]{3}\s?[0-9]{2}$/,
  NO: /^[0-9]{4}$/,
  DK: /^[0-9]{4}$/,
  FI: /^[0-9]{5}$/,
  // US/CA
  US: /^[0-9]{5}(-[0-9]{4})?$/,
  CA: /^[A-Z][0-9][A-Z]\s?[0-9][A-Z][0-9]$/i,
  // Others (fallback common numeric 3-10)
  PL: /^[0-9]{2}-?[0-9]{3}$/,
  CZ: /^[0-9]{3}\s?[0-9]{2}$/,
  SK: /^[0-9]{3}\s?[0-9]{2}$/,
  IE: /^[A-Z0-9]{3}\s?[A-Z0-9]{4}$/i, // Eircode
};

export function isValidPostalCode(
  value: string | undefined | null,
  country?: string | null,
): boolean {
  const v = (value || '').trim();
  if (v.length === 0) return true; // treat empty as valid; requiredness handled by form rules
  const c = (country || '').toUpperCase();
  const regex = patterns[c];
  if (!regex) {
    // Fallback: allow 2-10 of letters, digits, spaces, dash
    return /^[A-Z0-9\-\s]{2,10}$/i.test(v);
  }
  return regex.test(v);
}

export function normalizePostalCode(
  value: string | undefined | null,
  country?: string | null,
): string {
  const v = (value || '').trim();
  const c = (country || '').toUpperCase();
  // Country-specific normalization (spacing, uppercase).
  // Length of the part after the space: GB "SW1A 1AA", CA "K1A 0B1", NL "1234 AB", IE "D02 W3F9".
  const tails: Record<string, number> = { GB: 3, CA: 3, NL: 2, IE: 4 };
  const tail = tails[c];
  if (tail) {
    return v
      .replace(/\s+/g, '')
      .toUpperCase()
      .replace(new RegExp(`(.{${tail}})$`), ' $1')
      .trim();
  }
  return v;
}
